import { Box, Typography } from '@mui/material'
import Dialog, { type DialogProps } from '@mui/material/Dialog'
import ThemeButton from 'common/ui/theme-button'
import { BUTTON_SIZE, BUTTON_VARIANTS } from 'common/ui/theme-button/ThemeButton'
import { format } from 'date-fns'
import { type ListAIVendor, type ListVendor } from 'features/vendors/vendorList.types'
import React, { type ReactElement } from 'react'

import styles from './RejectionReasonDialog.module.scss'

interface RejectionReasonDialogProps extends DialogProps {
  open: boolean
  vendor: ListVendor | ListAIVendor
  confirmButtonAction?: () => void
  onClose: () => void
}

const RejectionReasonDialog: React.FC<RejectionReasonDialogProps> = ({
  open,
  vendor,
  confirmButtonAction,
  onClose,
  ...rest
}): ReactElement => {
  const retryDate =
    'aiVerificationRetryDate' in vendor
      ? vendor.aiVerificationRetryDate
      : 'verificationRetryDate' in vendor
      ? vendor.verificationRetryDate
      : ''

  return (
    <Dialog
      open={open}
      {...rest}
      sx={{
        '& .MuiPaper-root': {
          borderRadius: 0,
        },
      }}
    >
      <Box className={styles.container}>
        <div>
          <Typography variant="paragraph">Razlog odbijanja ovog vendora</Typography>
        </div>
        <div className={styles.divider}></div>
        <div className={styles.note}>
          <Typography variant="subtitle1">
            {'aiStatus' in vendor ? vendor.aiVerificationNote : vendor.verificationNote}
          </Typography>
        </div>
        <div>
          <Typography variant="paragraph">Datum kada ponovo može da se traži verifikacija</Typography>
        </div>
        <div className={styles.divider}></div>
        <div className={styles.date}>
          <Typography variant="subtitle2">
            {retryDate && format(new Date(retryDate), 'dd/MM/yyyy')}
          </Typography>
        </div>
        <div className={styles.action}>
          <ThemeButton
            onClick={confirmButtonAction}
            variant={BUTTON_VARIANTS.secondary}
            size={BUTTON_SIZE.small}
          >
            OK
          </ThemeButton>
        </div>
      </Box>
    </Dialog>
  )
}

export default RejectionReasonDialog
